import PropTypes from 'prop-types';
import React, { useCallback, useRef, useState } from 'react';
import scrollparent from 'scrollparent';

import ConversationItem from 'models/conversation_item';
import ConversationItemMenuContainer from './conversation_item_menu_container';
import { MenuContainer } from 'components/lib/menu_deprecated';
import TaskAnalyticsLocations from 'actions/conversation_item/task/task_analytics_locations';
import TrackItemMenuOpened from 'actions/conversation_item/task/track_item_menu_opened';
import { useExecuteAction } from 'components/hooks/connect_hooks';

export default function ConversationItemMenuOpener({ item, location, onOpenPinToCustomer, renderButton }) {
  const [isOpen, setIsOpen] = useState(false);
  const executeAction = useExecuteAction();

  const onClick = useCallback(() => {
    setIsOpen(true);
    const itemType = item.contentType();
    executeAction(TrackItemMenuOpened, {
      itemId: item.id,
      itemType,
      location: location || TaskAnalyticsLocations.TASK_ITEM,
    });
  }, [executeAction, item, location]);

  const onClose = useCallback(() => setIsOpen(false), []);

  const [scrollParent, setScrollParent] = useState(null);
  const menuRef = useRef(null);
  const setRef = useCallback(ref => {
    menuRef.current = ref;
    menuRef.current && setScrollParent(scrollparent(menuRef.current.container));
  }, []);

  return (
    <MenuContainer
      button={renderButton()}
      className="conversationItemMenu"
      onClick={onClick}
      onClose={onClose}
      positionInside={scrollParent}
      ref={node => setRef(node)}
    >
      {isOpen ? <ConversationItemMenuContainer item={item} onOpenPinToCustomer={onOpenPinToCustomer} /> : null}
    </MenuContainer>
  );
}

ConversationItemMenuOpener.propTypes = {
  item: PropTypes.instanceOf(ConversationItem).isRequired,
  location: PropTypes.string,
  onOpenPinToCustomer: PropTypes.func,
  renderButton: PropTypes.func.isRequired,
};
